import styled from "styled-components";
import Icon from "../atoms/Icon/Icon";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootStore } from "../../store/Store";
import { StyledImg, StyledSpan } from "../../styled";
import { useEffect } from "react";
import { setNotificationUnradCount } from "../../store/actions/notification/NotificationActions";
import { GET_MEDIA, GET_NOTIFICATION } from "../../api-calls";
import LanguageSwitchButton from "../molecules/languageSwitch/LanguageSwitchButton";
import { useTranslation } from "react-i18next";

const WrapperDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 52px;
`;

const ProfileDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
const ActionDiv = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const NameSpan = styled.span`
  color: ${(theme: any) => theme.theme.Light4};
  font-weight: 500;
  font-size: 14px;
  line-height: 22px;
  margin-inline-start: 10px;
`;

const GreenEllipseWrapper = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  width: 16px;
  height: 16px;
  background: ${(theme: any) => theme.theme.bgPrimary};
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const MobileDashboardHeader: React.FC = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const UserState = useSelector((state: RootStore) => state.user);
  const condition = localStorage.getItem("isLogin");
  const NotificationState = useSelector(
    (state: RootStore) => state.notification
  );
  useEffect(() => {
    const getNotif = () => {
      GET_NOTIFICATION().then(
        (res) => {
          dispatch(setNotificationUnradCount(res.data.data.unseenCount));
        },
        (error) => {}
      );
    };
    if (!!condition) {
      getNotif();
    }
  }, [NotificationState.unreadCount, condition, dispatch]);
  /**
   * Handle Log Out User
   */
  const handleClick = () => {
    history.push("/setting");
  };
  const { i18n } = useTranslation();
  const isRtl = i18n.dir() === "rtl";
  const style: React.CSSProperties = isRtl
    ? { position: "absolute", left: "100px" }
    : { position: "absolute", right: "100px" };
  /**
   * Main Ui Component
   */
  return (
    <WrapperDiv className="container">
      <ProfileDiv
        onClick={(e) => {
          handleClick();
        }}
      >
        {UserState.user?.imageCode ? (
          <StyledImg
            src={GET_MEDIA(UserState.user?.imageCode)}
            width="32px"
            height="32px"
            customStyle={"border-radius: 50%; object-fit: cover;"}
          ></StyledImg>
        ) : (
          <Icon name="profile" width="32px" height="32px"></Icon>
        )}
        <NameSpan>{UserState.user?.firstName}</NameSpan>
      </ProfileDiv>
      <div style={style}>
        <LanguageSwitchButton />
      </div>
      <ActionDiv>
        <Link to="/crypto/trade/history" style={{ margin: "4px" }}>
          <Icon name="orders" width="32px" height="32px"></Icon>
        </Link>
        {/* <Link to="/news" style={{ margin: "4px" }}>
          <Icon name="news" width="32px" height="32px"></Icon>
        </Link> */}
        <Link
          to="/notification"
          style={{ margin: "4px", position: "relative" }}
        >
          {!!NotificationState.unreadCount && (
            <GreenEllipseWrapper>
              <StyledSpan fontSize="10px" color="white" weight="500">
                {NotificationState.unreadCount}
              </StyledSpan>
            </GreenEllipseWrapper>
          )}
          <Icon name="notificationOff" width="32px" height="32px"></Icon>
        </Link>
      </ActionDiv>
    </WrapperDiv>
  );
};

export default MobileDashboardHeader;

// <Icon name="favoriteOff" width="32px" height="32px"></Icon>
